// extracted by mini-css-extract-plugin
module.exports = {"Loader":"Loader_Loader__2VLGK","center":"Loader_center__3SFDH"};